import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate';
import { es } from '@braid/vue-formulate-i18n';
import 'vue-select/dist/vue-select.css';
import VueFormulateDatepickerPlugin from 'vue-formulate-datepicker';
import TriotecaDatepickerPlugin from '@/funnels/components/form/datepicker';
import FormulateVueCurrencyPlugin from '@/funnels/components/form/currency';
import '@sum.cumo/vue-datepicker/dist/Datepicker.css';
import InputSliderPlugin from '@/funnels/components/form/inputSlider';
import FormulateVuePhonePlugin from '@/funnels/components/form/phone';
import TriotecaSelectPlugin from '@/funnels/components/form/triotecaSelect';
import FormulateVuePercentPlugin from '@/funnels/components/form/percent';
import FormulateVueCustomCheckboxPlugin from '@/funnels/components/form/customCheckbox';
import FormulateVueCustomDisclaimerPlugin from '@/funnels/components/form/customDisclaimer';
import FormulateVueTown from '@/funnels/components/form/town';
import Carousel from '@/web/carousel/Carousel';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Label from '@/funnels/components/form/Label';
import AutoholderDirective from '@/directives/autoholder';
import SyncFormDirective from '@/directives/sync-form';
import ErrorsSnap from '@/directives/errors-snap';

Vue.directive('autoholder', AutoholderDirective);
Vue.directive('sync-form', SyncFormDirective);
Vue.directive('errors-snap', ErrorsSnap);

Vue.component('carousel', Carousel);

Vue.use(VueFormulate, {
  plugins: [
    es,
    VueFormulateDatepickerPlugin,
    TriotecaDatepickerPlugin,
    FormulateVueCurrencyPlugin,
    FormulateVuePhonePlugin,
    InputSliderPlugin,
    FormulateVueCustomCheckboxPlugin,
    FormulateVueCustomDisclaimerPlugin,
    TriotecaSelectPlugin,
    FormulateVuePercentPlugin,
    FormulateVueTown,
  ],
  slotComponents: {
    label: Label,
  },
});
